import {
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
} from "@/components/ui/sidebar"
// import Logo from '@/assets/white-transparent.svg'
import { Link } from "@tanstack/react-router"

export function Topbar() {
    // const { isMobile } = useSidebar()

    return (
        <SidebarMenu>
            <SidebarMenuItem>
                <Link to='/'>
                    <SidebarMenuButton
                        size="lg"
                        className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground flex items-center justify-center"
                    >
                        <svg 
                            version="1.1" 
                            className="h-10 w-10" 
                            xmlns="http://www.w3.org/2000/svg" 
                            xmlnsXlink="http://www.w3.org/1999/xlink" 
                            viewBox="40 40 120 120"
                        >
                            <path 
                                className="fill-black dark:fill-white" 
                                d="m48.898 40v68.98c0 31.53 19.662 51.02 51.362 51.02 29.659 0 48.641-17.458 50.676-45.932-5.2547 5.9328-20.169 19.83-33.559 23.389v-0.16992c-7.6269 2.0343-15.423 0.84791-16.441 0.67773-4.2364-0.67809-7.7954-2.0323-10.508-3.2207-9.1532-3.8962-14.916-13.219-14.916-25.762v-68.98zm75.932 0v68.982c0 1.8642-0.17007 3.5595-0.33789 5.2559 5.4225-1.8665 9.9987-4.4082 12.541-6.4414 8.1349-6.1018 14.068-12.883 14.068-22.205v-45.592z" 
                            />
                        </svg>
                    </SidebarMenuButton>
                </Link>
            </SidebarMenuItem>
        </SidebarMenu>
    )
}
